/**
 * Config: Canvas
 * -----------------------------------------------------------------------------
 * Custom config for Canvas, allows limited access to compiler config.
 *
 */
module.exports = {

  /**
   * Theme scripts async config.
   * - Scripts included will be loaded with `async` attribute.
   * - Other scripts default to `defer` attribute.
   */
  asyncScripts: [
    'bundle.global-components.js',
    'bundle.vendors.js',
    'layout.password.js',
    'layout.theme.js',
  ],

  /**
   * CSS optimiser config.
   * - `classes` - Set classes to optimise (remove if not used).
   * - `enable` - Run CSS optimiser.
   * - `enableDevMode` - Run CSS optimiser in development mode (watch).
   * - `keep` - Do not remove these classes even if not used.
   * - `stylesheets` - Set stylesheets to optimise (remove unused classes from).
   */
  cssOptimiser: {
    classes: [
      'checkbox',
      'grid',
      'radio',
      'text-',
    ],
    enable: true,
    keep: [
      'l3-10',
      'l3-12',
      'l5',
      'l2',
      'l7-11',
      'l4-9',
      'l8-12',
    ],
    stylesheets: ['layout.theme.css'],
  },

  /**
   * Array of custom elements not to be compiled by Vue.
   */
  customElements: [],

  /**
   * Set to true if using the custom content tool.
   */
  customContentTool: false,

  /**
   * Set breakpoints that are considered mobile.
   */
  mobileBreakpoints: ['xs', 's', 'm'],
}
